import axios from 'axios';
import { IResultState } from './resultInterfaces';
import { IAppContext } from '../context/DefaultAppState';
import IDoctorSpecialty from '../interfaces/IDoctorSpecialty';
import IFacilitySpecialty from '../interfaces/IFacilitySpecialty';
import { getCurrentPosition } from './util';


const getPlanData = async (appContext: IAppContext) => {
  var planUrl = window.location.host; //changed from const to var
  //Added for provider directory search by plan name to be supported in dev sites
  planUrl = planUrl.trim();
  if(planUrl == "agerightdev.wpengine.com"){
	planUrl = "agerightadvantage.com";
  }
  if(planUrl == "alignscrdev.wpengine.com"){
	planUrl = "alignseniorcare.com";
  }
  if(planUrl == "keycaredev.wpengine.com"){
	planUrl = "keycareadvantage.com";
  }
  if(planUrl == "lifeworkdev.wpengine.com"){
	planUrl = "lifeworksadvantage.com";
  }
  if(planUrl == "nhcadvdev.wpengine.com"){
	planUrl = "nhcadvantageplan.com";
  }
  if(planUrl == "perennialaddev.wpengine.com"){
	planUrl = "perennialadvantage.com";
  }
  if(planUrl == "procareadvdev.wpengine.com"){
	planUrl = "procareadvantageplan.com";
  }
  if(planUrl == "pruittpremdev.wpengine.com"){
	planUrl = "pruitthealthpremier.com";
  }
  //TODO: Undo before deployment
  //const planUrl = 'alignseniorcare.com';
  //const planUrl = 'nhcadvantageplan.com';

  try {
    const { data } = await axios.get(`/Plans`);
    const plans = data?.filter((p: any) => p.planSite === planUrl);

    if(plans) {
      const plan = plans[0];
      document.documentElement.setAttribute('theme', plan.styleTheme);
      appContext.updatePlanName(plan.name);
	  appContext.updateShortPlanName(plan.shortPlanName); //Added for provider directory search by plan name
      appContext.updatePlansData(plans);
	  //console.log('plans->'+JSON.stringify(plans));
	  //var planStates = [];
	  /*const planStates = plans.forEach((planData, index) => {
		planStates.push(planData.state);
		// console.log('planStates->'+planData.state);
	  });*/
	  
	  //console.log('planStates->'+planStates);
    }
  } catch (err) {
    console.error(err);
  }
}


// const getTheme = (appContext: IAppContext) => {
//   const planUrl = window.location.host;
//   const plan = plansData.find((pd) => pd.site === planUrl);
//
//   if (plan) {
//     document.documentElement.setAttribute('theme', plan.theme);
//     appContext.updatePlanName(plan.name);
//     appContext.updatePlan(plan);
//     console.log('INIT PLAN: ', plan);
//   }
// };

const getDoctorSpecialties = async (appContext: IAppContext) => {
  try {
    const res = await axios.get(`/DoctorSpecialties`);
    const specialties: IDoctorSpecialty[] = res.data;
    appContext.updateDoctorSpecialties(specialties);
  } catch (err) {
    console.error(err);
  }
};

const getFacilitySpecialties = async (appContext: IAppContext) => {
  try {
    const res = await axios.get(`/FacilitySpecialties`);
    const specialties: IFacilitySpecialty[] = res.data;
    appContext.updateFacilitySpecialties(specialties);
  } catch (err) {
    console.error(err);
  }
};

const getPharmacySpecialties = async (appContext: IAppContext) => {
  try {
    const res = await axios.get(`/PharmacySpecialties`);
    const specialties: string[] = res.data;
    appContext.updatePharmacySpecialties(specialties);
  } catch (err) {
    console.error(err);
  }
};

// const getStates = async (appContext: IAppContext) => {
//   const emptyStateOption: IResultState = {
//     state: 'Pick your state',
//     abbreviation: 'default',
//     code: 'default'
//   };
//
//   try {
//     const { data } = await axios.get(`/States`);
//     const states = data;
//     console.log('STATES REQ: ', states);
//     states.unshift(emptyStateOption);
//     appContext.updateStateList(states);
//   } catch (err) {
//     console.error(err);
//   }
// };

const getCacheTime = async (appContext: IAppContext) => {
  try {
    const { data } = await axios.get(`/CacheTime`);
    appContext.updateCacheTime(data);
  } catch (err) {
    console.error(err);
  }
};

const getCurrentOrigin = async (appContext: IAppContext) => {
  let browserPosition = false;
  try {
    let currentLocation = { lat: 0, lng: 0 };
    /* const res: any = await getCurrentPosition();
    const { latitude, longitude } = res.coords;
    currentLocation.lat = latitude;
    currentLocation.lng = longitude;
    
    browserPosition = true; */
    //appContext.updateOrigin(currentLocation);
  } catch (err) {
    console.error(err);
  }
  if (!browserPosition) {
    try {
      let currentLocation = { lat: 0, lng: 0 };
      //const address = `${appContext.planState}`.split(' ').join('+');
      //console.log(address);
      // const geocode = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${process.env.REACT_APP_MAPS_API_KEY}`);
      // //planLocation = geocode.data.results[0]?.geometry?.location;

      // const { latitude, longitude } = geocode.data.results[0]?.geometry?.location;;
      // currentLocation.lat = latitude;
      // currentLocation.lng = longitude;
      // console.log('Lat: ', latitude);
      // console.log('Lng: ', longitude);
      //appContext.updateOrigin(currentLocation);
    } catch (err) {
      //console.log(err);
    }
  };
}

const initializeApp = async (appContext: IAppContext) => {
  await getPlanData(appContext);
  // getTheme(appContext);
  await getCacheTime(appContext);
  // await getStates(appContext);
  await getDoctorSpecialties(appContext);
  await getFacilitySpecialties(appContext);
  await getPharmacySpecialties(appContext);
  //await getCurrentOrigin(appContext);
  // TODO: Add Loading Complete Update Here
};

export default initializeApp;
